module.exports = __webpack_public_path__ + "img/table.4e74dc14.png";